import React from 'react';

export const EuropeMap = () => {
  return (
    <div className="relative w-full h-full flex items-center justify-center">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `
              linear-gradient(to right, #10B981 1px, transparent 1px),
              linear-gradient(to bottom, #10B981 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px'
          }}
        />
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] rounded-full"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(16, 185, 129, 0.08) 0%, transparent 70%)'
          }}
        />
      </div>

      {/* Europe Map Image - Vintage Style with Company Colors */}
      <div className="relative w-full max-w-4xl flex items-center justify-center">
        <img 
          src="https://static.prod-images.emergentagent.com/jobs/603f6781-2bae-4656-ade0-f47f4f6ad292/images/1bfc3ee6262759145a453718016c0d1c0ab2028b9821c7b8051e267a9c9602df.png"
          alt="Map of Europe"
          className="w-full h-auto max-h-[500px] object-contain rounded-lg"
          style={{
            filter: 'drop-shadow(0 4px 30px rgba(16, 185, 129, 0.3))'
          }}
        />
      </div>
    </div>
  );
};

export default EuropeMap;
